var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgTelegram = function SvgTelegram(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 240",
    fill: "none",
    preserveAspectRatio: "xMidYMid meet",
    ref: ref,
    "aria-labelledby": titleId
  }), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 240,
    height: 240,
    rx: 80,
    ry: 80,
    fill: "#47aaec"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M179.7 72.3L155.9 177.5C154.4 183.8 150.9 185.1 145.5 182.2L118.3 161.1L104.5 173.9C102.8 175.6 101.4 177 98.3 177.1L100.3 148.6L157.5 96.3C159.9 94.2 157.2 93 154.2 95.1L85.6 137.1L58.3 128.8C52.1 126.9 52 122.7 59.1 119.7L171.1 70.1C175.4 68.3 179.1 70.7 179.7 72.3Z",
    fill: "#fff",
    transform: "translate(0, -8)"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTelegram);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;